"use strict";

var _regeneratorRuntime = require("/home/jenkins/workspace/cycle_embedded-zam_PROD_20230416/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireWildcard(require("react"));

var _formik = require("formik");

var _button = _interopRequireDefault(require("@zipwhip/zipkit/dist/components/button"));

var _inputErrorWrapper = _interopRequireDefault(require("@zipwhip/zipkit/dist/components/inputs/input-error-wrapper"));

var _styledText = _interopRequireDefault(require("@zipwhip/zipkit/dist/components/styled-text"));

var _addressForm = _interopRequireDefault(require("../address-form"));

var _validate = _interopRequireDefault(require("./validate"));

var _creditCardInput = _interopRequireDefault(require("../credit-card-input"));

var _dropDown = _interopRequireDefault(require("../drop-down"));

var _textFormField = _interopRequireDefault(require("../text-form-field"));

var _utils = require("../../utils");

var _constants = require("../../constants");

require("./billing-form.scss");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
} // field names for the credit card
// also used as keys for hidden zuora inputs


var CARD_NAME = 'field_creditCardHolderName';
var CARD_NUMBER = 'number';
var EXPIRATION_MONTH = 'creditCardExpirationMonth';
var EXPIRATION_YEAR = 'creditCardExpirationYear';
var SECURITY_CODE = 'creditCardSecurityCode'; // only input not handled by the hiddent input in the name of credit card

var ZuoraHiddenFeilds = function ZuoraHiddenFeilds(props) {
  var pageId = props.pageId,
      showPaymentAddress = props.showPaymentAddress,
      signature = props.signature,
      tenantId = props.tenantId,
      token = props.token,
      values = props.values,
      zuoraKey = props.zuoraKey; // these constants determine what valuies the hidden inputs will be using
  // if showing the payment address use those form values otherwise use the account details address as payment address

  var address1 = showPaymentAddress ? _constants.BILLING_ADDRESS_1 : _constants.ACCOUNT_ADDRESS_1;
  var address2 = showPaymentAddress ? _constants.BILLING_ADDRESS_2 : _constants.ACCOUNT_ADDRESS_2;
  var city = showPaymentAddress ? _constants.BILLING_CITY : _constants.ACCOUNT_CITY;
  var country = showPaymentAddress ? _constants.BILLING_COUNTRY : _constants.ACCOUNT_COUNTRY;
  var postalCode = showPaymentAddress ? _constants.BILLING_POSTAL_CODE : _constants.ACCOUNT_POSTAL_CODE;
  var state = showPaymentAddress ? _constants.BILLING_STATE : _constants.ACCOUNT_STATE;
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement("input", {
    type: "hidden",
    name: "method",
    value: "submitPage"
  }), _react.default.createElement("input", {
    type: "hidden",
    name: "id",
    value: pageId
  }), _react.default.createElement("input", {
    type: "hidden",
    name: "tenantId",
    value: tenantId
  }), _react.default.createElement("input", {
    type: "hidden",
    name: "token",
    value: token
  }), _react.default.createElement("input", {
    type: "hidden",
    name: "signature",
    value: signature
  }), _react.default.createElement("input", {
    type: "hidden",
    name: "host",
    value: window.location.origin
  }), _react.default.createElement("input", {
    type: "hidden",
    name: "field_key",
    value: zuoraKey
  }), _react.default.createElement("input", {
    type: "hidden",
    name: "encrypted_fields",
    value: "#field_creditCardNumber#field_cardSecurityCode#field_creditCardExpirationMonth#field_creditCardExpirationYear"
  }), _react.default.createElement("input", {
    type: "hidden",
    name: "encrypted_values",
    value: (0, _utils.encryptValues)({
      creditCardExpirationMonth: values[EXPIRATION_MONTH],
      cardSecurityCode: values[SECURITY_CODE],
      creditCardNumber: values[CARD_NUMBER] && values[CARD_NUMBER].split(' ').join(''),
      creditCardExpirationYear: values[EXPIRATION_YEAR]
    }, zuoraKey)
  }), _react.default.createElement("input", {
    type: "hidden",
    name: "field_style",
    value: "iframe"
  }), _react.default.createElement("input", {
    type: "hidden",
    name: "field_creditCardHolderName",
    value: values[CARD_NAME]
  }), _react.default.createElement("input", {
    type: "hidden",
    name: "field_creditCardType",
    value: (0, _utils.getCardType)(values[CARD_NUMBER])
  }), _react.default.createElement("input", {
    type: "hidden",
    name: "field_creditCardAddress1",
    value: values[address1]
  }), _react.default.createElement("input", {
    type: "hidden",
    name: "field_creditCardAddress2",
    value: values[address2]
  }), _react.default.createElement("input", {
    type: "hidden",
    name: "field_creditCardCity",
    value: values[city]
  }), _react.default.createElement("input", {
    type: "hidden",
    name: "field_creditCardCountry",
    value: values[country]
  }), _react.default.createElement("input", {
    type: "hidden",
    name: "field_creditCardState",
    value: values[state]
  }), _react.default.createElement("input", {
    type: "hidden",
    name: "field_creditCardPostalCode",
    value: values[postalCode]
  }));
};

var BillingForm = function BillingForm(_ref) {
  var _ref4;

  var _ref$accountInfo = _ref.accountInfo,
      accountInfo = _ref$accountInfo === void 0 ? {} : _ref$accountInfo,
      _ref$axios = _ref.axios,
      axios = _ref$axios === void 0 ? _axios.default : _ref$axios,
      _ref$enableCreditCard = _ref.enableCreditCardAutofill,
      enableCreditCardAutofill = _ref$enableCreditCard === void 0 ? false : _ref$enableCreditCard,
      onCancel = _ref.onCancel,
      _ref$submitText = _ref.submitText,
      submitText = _ref$submitText === void 0 ? 'Continue' : _ref$submitText,
      version = _ref.version,
      _ref$zuoraPageId = _ref.zuoraPageId,
      zuoraPageId = _ref$zuoraPageId === void 0 ? '2c92c0f96d425700016d4721054f33c5' : _ref$zuoraPageId,
      _ref$zuoraUri = _ref.zuoraUri,
      zuoraUri = _ref$zuoraUri === void 0 ? 'https://apisandbox.zuora.com/apps/PublicHostedPageLite.do' : _ref$zuoraUri;

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      key = _useState2[0],
      setKey = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      signature = _useState4[0],
      setSignature = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = _slicedToArray(_useState5, 2),
      tenantId = _useState6[0],
      setTenantId = _useState6[1];

  var _useState7 = (0, _react.useState)(''),
      _useState8 = _slicedToArray(_useState7, 2),
      token = _useState8[0],
      setToken = _useState8[1];

  var formEl = (0, _react.useRef)(null);
  var address1 = accountInfo.address1,
      address2 = accountInfo.address2,
      city = accountInfo.city,
      _accountInfo$country = accountInfo.country,
      country = _accountInfo$country === void 0 ? 'US' : _accountInfo$country,
      state = accountInfo.state,
      postalCode = accountInfo.postalCode;
  (0, _react.useEffect)(function () {
    generateSignature(); // eslint-disable-next-line
  }, []);
  /**
   * Generates Signaute, creates the key, signature, tenant id and token needed to post directly to zuora
   * @public
   */

  var generateSignatureUrl = version ? "/".concat(version, "/billing/generateSignature") : '/billing/generateSignature';

  var generateSignature =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var _ref3, cargo, _key, _signature, _tenantId, _token;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!key && !signature && !tenantId && !token)) {
                _context.next = 6;
                break;
              }

              _context.next = 3;
              return axios.post(generateSignatureUrl, {
                method: 'POST',
                pageId: zuoraPageId,
                uri: zuoraUri
              });

            case 3:
              _ref3 = _context.sent;
              cargo = _ref3.data.cargo;

              if (cargo) {
                _key = cargo.key, _signature = cargo.signature, _tenantId = cargo.tenantId, _token = cargo.token;
                setKey(_key);
                setSignature(_signature);
                setTenantId(_tenantId);
                setToken(_token);
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function generateSignature() {
      return _ref2.apply(this, arguments);
    };
  }();

  var hanldeShouldDisableSubmit = function hanldeShouldDisableSubmit(values) {
    var validateHasAddress1 = (0, _utils.addressIsInvalid)(values[_constants.BILLING_ADDRESS_1]);
    var validateCardHasNotExpired = (0, _utils.cardIsExpired)(values[EXPIRATION_MONTH], values[EXPIRATION_YEAR]);
    var validateCity = (0, _utils.cityIsInvalid)(values[_constants.BILLING_CITY]);
    var validateHasPostalCode = !values[_constants.BILLING_POSTAL_CODE];
    var validateHasState = !values[_constants.BILLING_STATE];
    var validateHasCardName = !values[CARD_NAME];
    var validateHasCardNumber = !values[CARD_NUMBER];
    var validateHasExpirationMonth = !values[EXPIRATION_MONTH];
    var validateHasExpirationYear = !values[EXPIRATION_YEAR];
    var validateSecurityCode = (0, _utils.cvvLengthInvalid)(values[CARD_NUMBER], values[SECURITY_CODE]);
    return validateHasAddress1 || validateCity || validateCardHasNotExpired || validateHasPostalCode || validateHasState || validateHasCardName || validateHasCardNumber || validateHasExpirationMonth || validateHasExpirationYear || validateSecurityCode;
  };

  var submitHtmlForm = function submitHtmlForm() {
    if (formEl !== null && formEl.current) {
      formEl.current.submit();
    }
  };

  var hasOnCancel = !!onCancel;
  return _react.default.createElement("div", {
    className: "billing-form_pageContainer"
  }, _react.default.createElement("div", {
    className: "billing-form_panelContent"
  }, _react.default.createElement(_formik.Formik, {
    initialValues: (_ref4 = {}, _defineProperty(_ref4, _constants.BILLING_ADDRESS_1, address1), _defineProperty(_ref4, _constants.BILLING_ADDRESS_2, address2), _defineProperty(_ref4, _constants.BILLING_CITY, city), _defineProperty(_ref4, _constants.BILLING_COUNTRY, country), _defineProperty(_ref4, _constants.BILLING_POSTAL_CODE, postalCode), _defineProperty(_ref4, _constants.BILLING_STATE, state), _defineProperty(_ref4, _constants.BILLING_COUNTRY, 'US'), _ref4),
    onSubmit: function onSubmit() {},
    validateOnBlur: true,
    validateOnChange: false,
    validationSchema: _validate.default,
    render: function render(_ref5) {
      var errors = _ref5.errors,
          handleChange = _ref5.handleChange,
          setFieldValue = _ref5.setFieldValue,
          setFieldTouched = _ref5.setFieldTouched,
          values = _ref5.values,
          touched = _ref5.touched;
      var cardIsValid = (0, _utils.creditCardIsValid)(values[CARD_NUMBER]);
      return _react.default.createElement("div", {
        className: "billing-form_container"
      }, _react.default.createElement("form", {
        action: zuoraUri,
        method: "post",
        name: "Payment2Form",
        ref: formEl
      }, _react.default.createElement(ZuoraHiddenFeilds, {
        zuoraKey: key,
        pageId: zuoraPageId,
        showPaymentAddress: true,
        signature: signature,
        tenantId: tenantId,
        token: token,
        values: values
      })), _react.default.createElement(_textFormField.default, {
        autocomplete: enableCreditCardAutofill ? 'cc-name' : '',
        error: errors[CARD_NAME],
        id: "frmNameCC",
        label: "Name on Credit Card",
        name: CARD_NAME,
        onChange: handleChange,
        testid: "CREDIT_CARD_OWNER_NAME",
        touched: touched[CARD_NAME],
        value: values[CARD_NAME]
      }), _react.default.createElement(_styledText.default, {
        className: "billing-form_inputLabel"
      }, "Card Number"), _react.default.createElement(_formik.Field, {
        name: CARD_NUMBER,
        onChange: handleChange
      }, function (_ref6) {
        var field = _ref6.field;
        return _react.default.createElement(_inputErrorWrapper.default, {
          containerClassName: "billing-form_creditCardInput_errorContainer",
          error: touched[CARD_NUMBER] && errors[CARD_NUMBER] ? errors[CARD_NUMBER] : null
        }, _react.default.createElement(_creditCardInput.default, _extends({
          autocomplete: enableCreditCardAutofill ? 'cc-number' : '',
          id: "frmCCNum",
          className: "contact-billing-form_creditCardInput"
        }, field)));
      }), _react.default.createElement("div", {
        className: "billing-form_expirationSection"
      }, _react.default.createElement("div", null, _react.default.createElement(_styledText.default, {
        className: "billing-form_inputLabel"
      }, "Expiration Month"), _react.default.createElement(_inputErrorWrapper.default, {
        containerClassName: "contact-billing-form_creditCardInput_errorContainer",
        error: touched[EXPIRATION_MONTH] && errors[EXPIRATION_MONTH] ? errors[EXPIRATION_MONTH] : null
      }, _react.default.createElement(_formik.Field, {
        autoComplete: "cc-exp-month",
        className: "billing-form_expirationInput",
        component: _dropDown.default,
        error: touched[EXPIRATION_YEAR] && errors[EXPIRATION_YEAR],
        items: _constants.MONTH_VALUES,
        name: EXPIRATION_MONTH,
        onBlur: setFieldTouched,
        onChange: setFieldValue,
        placeholder: "Month",
        testid: "CREDIT_CARD_EXPIRATION_MONTH",
        selectedValue: values[EXPIRATION_MONTH]
      }))), _react.default.createElement("div", null, _react.default.createElement(_styledText.default, {
        className: "billing-form_inputLabel"
      }, "Expiration Year"), _react.default.createElement(_formik.Field, {
        autoComplete: "cc-exp-year",
        className: "billing-form_expirationYear",
        component: _dropDown.default,
        items: (0, _utils.getYears)(),
        error: (0, _utils.cardIsExpired)(values[EXPIRATION_MONTH], values[EXPIRATION_YEAR]) ? 'Card is expired' : null,
        name: EXPIRATION_YEAR,
        onBlur: setFieldTouched,
        onChange: setFieldValue,
        placeholder: "Year",
        testid: "CREDIT_CARD_EXPIRATION_YEAR",
        selectedValue: values[EXPIRATION_YEAR]
      })), _react.default.createElement(_textFormField.default, {
        autocomplete: enableCreditCardAutofill ? 'cc-csc' : '',
        className: "billing-form_expirationInput",
        id: "frmCCCVC",
        label: "Security Code",
        error: errors[SECURITY_CODE],
        name: SECURITY_CODE,
        onChange: handleChange,
        pattern: "[0-9]+",
        placeholder: "CVC",
        touched: touched[SECURITY_CODE],
        type: "text",
        testid: "CREDIT_CARD_CVC",
        value: values[SECURITY_CODE]
      })), _react.default.createElement(_addressForm.default, {
        errors: errors,
        handleChange: handleChange,
        isPaymentAddress: true,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        touched: touched,
        values: values
      }), _react.default.createElement("div", {
        className: "button-form_buttonWrapper"
      }, _react.default.createElement(_react.Fragment, null, hasOnCancel && _react.default.createElement(_button.default, {
        className: "billing-form_cancelButton",
        secondary: true,
        onPress: onCancel
      }, "Cancel"), _react.default.createElement(_button.default, {
        disabled: hanldeShouldDisableSubmit(values) || !cardIsValid,
        className: (0, _classnames.default)('billing-form_button', {
          'billing-form_button_hasCancel': hasOnCancel
        }),
        large: !hasOnCancel,
        onClick: function onClick() {
          submitHtmlForm();
        },
        testid: "BILLING_FORM_SUBMIT_BUTTON"
      }, submitText))));
    }
  })));
};

var _default = BillingForm;
exports.default = _default;